import { useMemo } from "react";
import { Order } from "src/shared/services/interface";

type ReturnTotals = {
  qty: number;
  amount: number;
  refund: number;
  adjusted: number;

  remaining: number;
  totalPayment: number;
  adjustmentAmount: number;
  finalAmount: number;

  netReturn: number;
};

export const useReturnCalculation = (order: Order | null, returnQty: Record<number, number>, reverseDiscount: number): ReturnTotals => {
  return useMemo(() => {
    if (!order) {
      return {
        qty: 0,
        amount: 0,
        refund: 0,
        adjusted: 0,
        remaining: 0,
        totalPayment: 0,
        adjustmentAmount: 0,
        finalAmount: 0,
        netReturn: 0,
      };
    }

    // 🔹 Base values
    const finalAmount = order.Finalamount ?? 0;

    const totalPayment = order.paymentHistory?.reduce((acc: number, p: { ReceivedAmount: number }) => acc + (p.ReceivedAmount || 0), 0) ?? 0;

    const adjustmentAmount = order.paymentHistory?.reduce<number>((acc, p) => acc + (p.adjustAmount ?? 0), 0) ?? 0;

    // 🔹 Remaining before return
    const remaining = finalAmount - totalPayment - adjustmentAmount;

    // 🔹 Return calculation
    let qty = 0;
    let amount = 0;

    order.Products?.forEach((p: any, i: number) => {
      const q = returnQty[i] || 0;
      const price = p.amount ?? 0;

      qty += q;
      amount += q * price;
    });

    const netReturn = amount - (reverseDiscount || 0);

    // 🔹 Adjust vs Refund
    const adjusted = Math.min(netReturn, remaining);
    const refund = netReturn - adjusted;

    return {
      qty,
      amount,
      refund,
      adjusted,

      remaining,
      totalPayment,
      adjustmentAmount,
      finalAmount,

      netReturn,
    };
  }, [order, returnQty, reverseDiscount]);
};
